var map = {
	"./Castle.json": "./src/metadata/render/Castle.json",
	"./Circles.json": "./src/metadata/render/Circles.json",
	"./Circuit.json": "./src/metadata/render/Circuit.json",
	"./FloorPlan.json": "./src/metadata/render/FloorPlan.json",
	"./Happyland.json": "./src/metadata/render/Happyland.json",
	"./Knots.json": "./src/metadata/render/Knots.json",
	"./Rooms.json": "./src/metadata/render/Rooms.json",
	"./Sudoku.json": "./src/metadata/render/Sudoku.json",
	"./Summer.json": "./src/metadata/render/Summer.json",
	"./TmwDesertSpacing.json": "./src/metadata/render/TmwDesertSpacing.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/metadata/render sync recursive ^\\.\\/.*\\.json$";